import { OPERATION_IDS, ROUTE_IDS } from './ids.js';
import { REPORTING_ROUTES } from './reporting-routes.js';
import { canonicalRouteRegistry as effectiveRoutes, getRouteOperationIdForPersona as getEffectiveOperation, } from './effective-routes.js';
/**
 * Released route projection.
 *
 * The governed organization regulatory-profile API and form are implemented in
 * this release, so the formerly planned route is promoted without mutating the
 * historical effective-route reconciliation logic. Reporting child routes are
 * owned by the reporting surface and appended here so every rendered reporting
 * workspace remains part of the canonical route authority.
 */
export const canonicalRouteRegistry = [
    ...effectiveRoutes.map((route) => route.routeId === ROUTE_IDS.ORGANIZATION_REGULATORY_PROFILE
        ? {
            ...route,
            availability: 'AVAILABLE',
            allowedPersonas: ['ORG_ADMIN'],
            navigationPlacement: 'hidden',
            operationId: OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_READ,
        }
        : route),
    ...REPORTING_ROUTES,
];
export function getRouteById(routeId) {
    return canonicalRouteRegistry.find((route) => route.routeId === routeId);
}
export function getRoutesByLayout(layoutId) {
    return canonicalRouteRegistry.filter((route) => route.layoutId === layoutId);
}
export function getRouteByPath(path) {
    const exact = canonicalRouteRegistry.find((route) => route.path === path);
    if (exact)
        return exact;
    for (const route of canonicalRouteRegistry) {
        if (!route.path.includes('/:'))
            continue;
        const pattern = route.path.replace(/:[^/]+/g, '[^/]+');
        if (new RegExp(`^${pattern}$`).test(path))
            return route;
    }
    return undefined;
}
export function getRouteOperationIdForPersona(route, persona) {
    if (route.routeId === ROUTE_IDS.ORGANIZATION_REGULATORY_PROFILE) {
        return persona === 'ORG_ADMIN'
            ? OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_READ
            : undefined;
    }
    const released = getRouteById(route.routeId);
    const releasedOperation = released?.operationVariants?.find((variant) => variant.personas.includes(persona))?.operationId
        ?? released?.operationId;
    return releasedOperation ?? getEffectiveOperation(route.routeId, persona);
}
export function getNavigationRoutes() {
    return canonicalRouteRegistry.filter((route) => route.availability === 'AVAILABLE' && route.navigationPlacement !== 'hidden');
}
export function isPublicRoute(route) {
    return route.authentication === 'public';
}
export function getRouteIds() {
    return canonicalRouteRegistry.map((route) => route.routeId);
}
